import { render, staticRenderFns } from "./TherapistInfo.vue?vue&type=template&id=bcb33438"
import script from "./TherapistInfo.vue?vue&type=script&lang=js"
export * from "./TherapistInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports